import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countFiltered',
  standalone: false,
})
export class CountFilteredPipe implements PipeTransform {
  transform(items: any[], counter: { count: number }): any[] {
    counter.count = items.length;
    return items;
  }
}
